<template>
  <div
    class="absolute z-50 inset-0 h-screen w-screen bg-secondary-500 flex flex-col justify-between content-center"
  >
    <div
      class="w-screen bottom-0 mb-24 text-primary-500 text-center font-sans text-xl"
    ></div>
    <div>
      <div class="w-screen text-center font-sans text-secondary-200 error-text">
        Sold Out :(
      </div>
      <div class="w-screen text-center font-sans text-secondary-400 text-xl">
        ...sorry dear! Maybe next time?!
      </div>
    </div>
    <div
      class="w-screen bottom-0 mb-24 text-primary-500 text-center font-sans text-xl"
    >
      <span class="opacity-50">Take me back to&nbsp;</span>
      <a :href="`/${seller.urlAlias}`" class="whitespace-nowrap">
        getnext.to / {{ seller.nickname }}
      </a>
    </div>
  </div>
</template>

<style>
.error-text {
  font-size: 130px;
}

@media (min-width: 768px) {
  .error-text {
    font-size: 180px;
  }
}
</style>

<script>
// /* global Stripe */

import dottie from 'dottie'
import { store } from '@/store'
import { sync } from 'vuex-pathify'

const fetchData = async (to, from, next) => {
  await store.dispatch('user/read', to.params.sellerId)
  await store.dispatch('reward/read', { rewardId: to.params.rewardId })

  next()
}

export default {
  beforeRouteEnter: fetchData,
  beforeRouteUpdate: fetchData,

  data() {
    return {
      $stripe: null,
      sessionId: null
    }
  },

  computed: {
    seller: sync('user'),
    reward: sync('reward/reward'),
    product: sync('reward/product'),

    amountSubscription() {
      return dottie.get(this.reward, 'amount', null)
    },

    amountProduct() {
      return dottie.get(this.product, 'amount', null)
    }
  },

  mounted() {
    if (window.fbq && this.amountSubscription) {
      window.fbq('track', 'Subscribe', {
        value: Number(this.amountSubscription / 100),
        currency: 'EUR'
      })
    }

    if (window.fbq && this.amountProduct) {
      window.fbq('track', 'Purchase', {
        value: Number(this.amountProduct / 100),
        currency: 'EUR'
      })
    }
  },

  methods: {}
}
</script>
